import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "size", "iconKey", "onClick", "children", "disabled", "hideTextOnOnePanel", "isLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { twMerge } from 'tailwind-merge';
import React from 'react';
import BaseButton from './BaseButton';
import Icon from './Icon';
import Loading from './Loading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// The ghost and danger styles draw their border with `ring-1`, a box-shadow,
// not with `outline`: the outline is the browser's focus ring, which the
// `focus-ring` on BaseButton shows on keyboard focus. Forced colours drop
// box-shadows, so there the border is an outline again.
export var colors = {
  basic: 'border-none',
  primary: 'bg-main text-textOnBrand border-none',
  secondary: 'bg-transparent hover:gray-200 border-none',
  gray: 'bg-gray-200 hover:darken-10 border-none',
  ghost: 'ring-main bg-transparent rounded-sm text-main ring-1 forced-colors:outline-1 disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-gray-400',
  danger: 'rounded-sm bg-transparent text-red ring-1 forced-colors:outline-1 ring-red hover:bg-red hover:text-white',
  icon: 'rounded-sm text-gray-600',
  white: 'rounded-sm bg-white text-gray-600 border-none hover:bg-gray-200'
};
var sizes = {
  small: 'text-xs/5',
  "default": 'px-2 py-2 text-sm/4'
};
var iconSize = {
  small: '1.25rem',
  "default": '1.5rem'
};
var Button = function Button(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'basic' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    iconKey = _ref.iconKey,
    onClick = _ref.onClick,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hideTextOnOnePan = _ref.hideTextOnOnePanel,
    hideTextOnOnePanel = _ref$hideTextOnOnePan === void 0 ? false : _ref$hideTextOnOnePan,
    isLoading = _ref.isLoading,
    props = _objectWithoutProperties(_ref, _excluded);
  if (iconKey && !children) {
    return /*#__PURE__*/_jsx(BaseButton, _objectSpread(_objectSpread({
      className: twMerge('flex size-8 items-center justify-center', colors[color], disabled ? 'cursor-default' : '', className),
      disabled: disabled,
      onClick: onClick
    }, props), {}, {
      children: /*#__PURE__*/_jsx(Icon, {
        iconKey: iconKey
      })
    }));
  }
  return /*#__PURE__*/_jsxs(BaseButton, _objectSpread(_objectSpread({
    className: twMerge('relative font-medium', colors[color], sizes[size], disabled ? 'cursor-default' : 'hover:darken-10', className, !hideTextOnOnePanel ? 'min-w-[120px]' : ''),
    disabled: disabled,
    onClick: onClick
  }, props), {}, {
    children: [iconKey ? /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-x-2 pe-1",
      children: [/*#__PURE__*/_jsx(Icon, {
        iconKey: iconKey,
        size: iconSize[size]
      }), /*#__PURE__*/_jsx("span", {
        className: twMerge(hideTextOnOnePanel && 'hidden sm:block'),
        children: children
      })]
    }) : children, isLoading && /*#__PURE__*/_jsx("div", {
      className: "absolute end-4",
      children: /*#__PURE__*/_jsx(Loading, {
        size: 16,
        disableTimeout: true
      })
    })]
  }));
};
export default Button;